import { FaFileAlt } from "react-icons/fa";
import { ROUTES } from "constants/routes-path";
import { Flex } from "@chakra-ui/react";
import CardList from "components/Card/CardList";

function QueriesSenatranList({ denatranNewPermissions = false }) {
  const baseRoute = `${ROUTES.panel}${ROUTES.transportManagement}${ROUTES.searches}${ROUTES.searchSenatran}`;

  const allItems = [
    {
      icon: FaFileAlt,
      route: `${baseRoute}${ROUTES.searchSenatranDrivers}`,
      titleKey: "queries.senatran.list.title.query-drivers",
      descriptionKey: "queries.senatran.list.description.query-drivers",
      requiresPermission: false,
    },
    {
      icon: FaFileAlt,
      route: `${baseRoute}${ROUTES.searchSenatranBasicVehicles}`,
      titleKey: "queries.senatran.list.title.query-basic-vehicles",
      descriptionKey: "queries.senatran.list.description.query-basic-vehicles",
      requiresPermission: false,
    },
    {
      icon: FaFileAlt,
      route: `${baseRoute}${ROUTES.searchSenatranDetailedVehicles}`,
      titleKey: "queries.senatran.list.title.query-detailed-vehicles",
      descriptionKey: "queries.senatran.list.description.query-detailed-vehicles",
      requiresPermission: false,
    },
    {
      icon: FaFileAlt,
      route: `${baseRoute}${ROUTES.searchSenatranViolations}`,
      titleKey: "queries.senatran.list.title.query-violations",
      descriptionKey: "queries.senatran.list.description.query-violations",
      requiresPermission: false,
    },
    {
      icon: FaFileAlt,
      route: `${baseRoute}${ROUTES.searchSenatranOwnerAddress}`,
      titleKey: "queries.senatran.list.title.query-owner-address",
      descriptionKey: "queries.senatran.list.description.query-owner-address",
      requiresPermission: true,
    },
    {
      icon: FaFileAlt,
      route: `${baseRoute}${ROUTES.searchSenatranViolationPayments}`,
      titleKey: "queries.senatran.list.title.query-violation-payments",
      descriptionKey: "queries.senatran.list.description.query-violation-payments",
      requiresPermission: true,
    },
    {
      icon: FaFileAlt,
      route: `${baseRoute}${ROUTES.searchSenatranViolationEvents}`,
      titleKey: "queries.senatran.list.title.query-violation-events",
      descriptionKey: "queries.senatran.list.description.query-violation-events",
      requiresPermission: true,
    },
  ];

  const items = allItems.filter((item) => !item.requiresPermission || denatranNewPermissions);

  return (
    <Flex
      gap="5"
      direction="column"
      pt={{ base: "180px", sm: "155px", lg: "90px" }}
      px="30px"
    >
      <CardList items={items} />
    </Flex>
  );
}

export default QueriesSenatranList;
